require("../../assets/unify/plugins/owl-carousel/owl-carousel/owl.carousel.css");

require("../../assets/unify/css/pages/page_search.css");
require("../../assets/unify/css/pages/page_log_reg_v1.css");


// WEBPACK FOOTER //
// ./webpack/finish/css.js